// extracted by mini-css-extract-plugin
module.exports = {"screen":"idt-mobile_screen__1oyvk"};